import React from 'react';
const PageLoader = () => {
    return (
    // <BouncyLoader />
    React.createElement(React.Fragment, null, "Bouncy Loader"));
};
export default PageLoader;
